import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ProjectMonitorRecordFollowWidgets from '../../../widgets/projectMonitorRecordFollowWidgets/ProjectMonitorRecordFollowWidgets'
import ContentHeaderWidget from '../../../components/ContentHeader/ContentHeaderWidget'
import { doneLoading, startLoading } from '../../../utils/loading'
import { getTracking } from '../../../redux/actions/subprojectTrackingHistory'
import { ERR_MSG_404_TEMPLETE_ID } from '../../../constants/msgText'
import { SUB_FOLLOW_ID, SUB_PROJECT_ID } from '../../../constants/constants'

export default function ProjectMonitorRecordFollow(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()

  const projectId = sessionStorage.getItem(SUB_PROJECT_ID)
  const followId = sessionStorage.getItem(SUB_FOLLOW_ID)

  useEffect(() => {
    if (projectId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_TEMPLETE_ID,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getTracking(null, projectId, followId)
      // const _schema = mockSchema
      setSchemas(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectDep6>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal isSubProjectDep6>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isSubProjectDep6>
        <ContentHeaderWidget header={schemas.header} subHeader={schemas.subHeader} />

        {/* <ProjectMonitorWidgets schema={exSchema.forms} /> */}
        {schemas.forms.trackingRecord && (
          <ProjectMonitorRecordFollowWidgets schema={schemas.forms.trackingRecord} />
        )}
      </SidebarProposal>
    </>
  )
}
